var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"cert-file-modal",attrs:{"top":"32px","title":"证书详情","visible":_vm.visible,"width":"560px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('iframe',{staticClass:"file-frame",attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }